(function () {
  const BRAND_STORAGE_KEY = 'ed_active_brand';
  const DEFAULT_BRAND = 'default';
  const SECONDARY_BRAND = 'ela-beauty';
  const THIRD_BRAND = 'alle-marken';

  function getCurrentLocalePrefix() {
    try {
      var pathname = window.location.pathname;
      var localeMatch = pathname.match(/^\/([a-z]{2}(?:-[a-z]{2,3})?)(?:\/|$)/i);
      if (localeMatch && localeMatch[1]) {
        var localeCode = localeMatch[1];
        if (pathname === '/' + localeCode || pathname === '/' + localeCode + '/' || pathname.startsWith('/' + localeCode + '/')) {
          return '/' + localeCode + '/';
        }
      }
      return '';
    } catch (e) {
      return '';
    }
  }

  function buildUrlWithLocale(path, localePrefix) {
    if (!localePrefix) {
      return path;
    }
    var cleanPath = path.replace(/^\//, '');
    var cleanLocale = localePrefix.replace(/\/$/, '');
    return cleanLocale + '/' + cleanPath;
  }

  function isBrandPage(path, brandPath) {
    if (path === brandPath || path === brandPath + '/') {
      return true;
    }
    var localeMatch = path.match(/^\/([a-z]{2}(?:-[a-z]{2,3})?)\//i);
    if (localeMatch && localeMatch[1]) {
      var localePrefix = '/' + localeMatch[1] + '/';
      var localizedPath = buildUrlWithLocale(brandPath, localePrefix);
      if (path === localizedPath || path === localizedPath + '/') {
        return true;
      }
    }
    return false;
  }

  (function () {
    try {
      var currentPath = window.location.pathname;

      if (isBrandPage(currentPath, '/pages/ela-beauty')) {
        localStorage.setItem(BRAND_STORAGE_KEY, SECONDARY_BRAND);
        var html = document.documentElement;
        html.setAttribute('data-brand', SECONDARY_BRAND);
        html.setAttribute('id', SECONDARY_BRAND);
        if (document.body) {
          document.body.setAttribute('data-brand', SECONDARY_BRAND);
          document.body.setAttribute('id', SECONDARY_BRAND);
        }
        return;
      }

      if (isBrandPage(currentPath, '/pages/alle-marken')) {
        localStorage.setItem(BRAND_STORAGE_KEY, THIRD_BRAND);
        var html = document.documentElement;
        html.setAttribute('data-brand', THIRD_BRAND);
        html.setAttribute('id', THIRD_BRAND);
        if (document.body) {
          document.body.setAttribute('data-brand', THIRD_BRAND);
          document.body.setAttribute('id', THIRD_BRAND);
        }
        return;
      }
    } catch (e) { }
  })();

  (function () {
    try {
      var currentPath = window.location.pathname;
      var localePrefix = getCurrentLocalePrefix();
      
      var isHomepage = currentPath === '/' || 
                       currentPath === '/index' || 
                       currentPath === '/index.html' ||
                       (localePrefix && (currentPath === localePrefix || currentPath === localePrefix.replace(/\/$/, '')));

      if (!isHomepage) {
        return;
      }

      var activeBrand = localStorage.getItem(BRAND_STORAGE_KEY) || DEFAULT_BRAND;
      var elaBeautyUrl = buildUrlWithLocale('/pages/ela-beauty', localePrefix);
      var alleMarkenUrl = buildUrlWithLocale('/pages/alle-marken', localePrefix);

      if (activeBrand === SECONDARY_BRAND && currentPath !== elaBeautyUrl && currentPath !== elaBeautyUrl + '/') {
        window.location.href = elaBeautyUrl;
        return;
      } else if (activeBrand === THIRD_BRAND && currentPath !== alleMarkenUrl && currentPath !== alleMarkenUrl + '/') {
        window.location.href = alleMarkenUrl;
        return;
      }
    } catch (e) { }
  })();

  function getActiveBrand() {
    try {
      return localStorage.getItem(BRAND_STORAGE_KEY) || DEFAULT_BRAND;
    } catch (e) {
      return DEFAULT_BRAND;
    }
  }

  function setActiveBrand(brand) {
    try {
      localStorage.setItem(BRAND_STORAGE_KEY, brand);
    } catch (e) {
      console.warn('Failed to save brand preference:', e);
    }
  }

  function applyBrandAttributes(brand) {
    const html = document.documentElement;
    const body = document.body;

    if (brand === SECONDARY_BRAND) {
      html.setAttribute('data-brand', SECONDARY_BRAND);
      html.setAttribute('id', SECONDARY_BRAND);
      if (body) {
        body.setAttribute('data-brand', SECONDARY_BRAND);
        body.setAttribute('id', SECONDARY_BRAND);
      }
    } else if (brand === THIRD_BRAND) {
      html.setAttribute('data-brand', THIRD_BRAND);
      html.setAttribute('id', THIRD_BRAND);
      if (body) {
        body.setAttribute('data-brand', THIRD_BRAND);
        body.setAttribute('id', THIRD_BRAND);
      }
    } else {
      html.setAttribute('data-brand', DEFAULT_BRAND);
      html.setAttribute('id', DEFAULT_BRAND);
      if (body) {
        body.setAttribute('data-brand', DEFAULT_BRAND);
        body.setAttribute('id', DEFAULT_BRAND);
      }
    }
  }

  function updateActiveBrandClass(brand) {
    const defaultBrand = document.getElementById('ed_default_brand');
    const secondaryBrand = document.getElementById('ed_secondary_brand');
    const thirdBrand = document.getElementById('ed_third_brand');

    if (defaultBrand) {
      if (brand === DEFAULT_BRAND) {
        defaultBrand.classList.add('active-brand');
      } else {
        defaultBrand.classList.remove('active-brand');
      }
    }

    if (secondaryBrand) {
      if (brand === SECONDARY_BRAND) {
        secondaryBrand.classList.add('active-brand');
      } else {
        secondaryBrand.classList.remove('active-brand');
      }
    }

    if (thirdBrand) {
      if (brand === THIRD_BRAND) {
        thirdBrand.classList.add('active-brand');
      } else {
        thirdBrand.classList.remove('active-brand');
      }
    }
  }

  function getPageBrandOverride() {
    try {
      if (!document.body) return null;

      var path = (window.location && window.location.pathname) || '';

      var isPdp =
        (document.body.classList && document.body.classList.contains('template-product')) ||
        (path && path.indexOf('/products/') !== -1);

      var isCollection =
        (document.body.classList && (document.body.classList.contains('template-collection') || document.body.classList.contains('template--collection'))) ||
        (path && path.indexOf('/collections/') !== -1);

      var isPage =
        (document.body.classList && (document.body.classList.contains('template-page') || document.body.classList.contains('template--page'))) ||
        (path && path.indexOf('/pages/') !== -1);

      if (isPdp) {
        var brandEl = document.querySelector('.pdp-title-wrap [data-brand-target]');
        if (!brandEl) {
          var hiddenMarker = document.querySelector('product-rerender [data-brand-target], .product [data-brand-target]');
          if (hiddenMarker) {
            brandEl = hiddenMarker;
          } else {
            return null;
          }
        }

        var targetBrand = brandEl.getAttribute('data-brand-target');
        if (!targetBrand) return null;
        return targetBrand;
      } else if (isCollection) {
        var collectionBrandEl = document.querySelector('.collection-brand-marker[data-brand-target]');
        if (!collectionBrandEl) {
          var allMarkers = document.querySelectorAll('.visibility-hidden[data-brand-target]');
          for (var i = 0; i < allMarkers.length; i++) {
            var marker = allMarkers[i];
            var isInProductItem = marker.closest('.product-item, .product-item-meta, .product-item-spotlight, .ela-product-item, product-item');
            if (!isInProductItem) {
              collectionBrandEl = marker;
              break;
            }
          }
        }
        if (collectionBrandEl) {
          var collectionTargetBrand = collectionBrandEl.getAttribute('data-brand-target');
          if (collectionTargetBrand) return collectionTargetBrand;
        }
        return null;
      } else if (isPage) {
        var pageBrandEl = document.querySelector('.page-brand-marker[data-brand-target]');

        if (!pageBrandEl) {
          var pageMarkers = document.querySelectorAll('[data-brand-target]');
          for (var j = 0; j < pageMarkers.length; j++) {
            var candidate = pageMarkers[j];
            var isInProductContext = candidate.closest('.product-item, .product-item-meta, .product-item-spotlight, .ela-product-item, product-item, .collection-brand-marker');
            if (!isInProductContext) {
              pageBrandEl = candidate;
              break;
            }
          }
        }

        if (pageBrandEl) {
          var pageTargetBrand = pageBrandEl.getAttribute('data-brand-target');
          if (pageTargetBrand) return pageTargetBrand;
        }
        if (isBrandPage(path, '/pages/ela-beauty')) {
          return SECONDARY_BRAND;
        } else if (isBrandPage(path, '/pages/alle-marken')) {
          return THIRD_BRAND;
        }

        return null;
      }

      return null;
    } catch (e) {
      return null;
    }
  }

  function applyEffectiveBrand(brand) {
    if (!brand) return;
    setActiveBrand(brand);
    applyBrandAttributes(brand);
    updateActiveBrandClass(brand);
  }

  function initBrandState() {
    var storedBrand = getActiveBrand();
    var overrideBrand = getPageBrandOverride();

    if (overrideBrand) {
      applyEffectiveBrand(overrideBrand);
    } else {
      applyEffectiveBrand(storedBrand);
    }
  }

  function switchBrand(brand, event) {
    if (event) {
      setActiveBrand(brand);
      event.preventDefault();

      var localePrefix = getCurrentLocalePrefix();
      var targetUrl = '';

      if (brand === DEFAULT_BRAND) {
        if (localePrefix) {
          targetUrl = localePrefix.replace(/\/$/, '');
        } else {
          targetUrl = '/';
        }
      } else if (brand === SECONDARY_BRAND) {
        targetUrl = buildUrlWithLocale('/pages/ela-beauty', localePrefix);
      } else if (brand === THIRD_BRAND) {
        targetUrl = buildUrlWithLocale('/pages/alle-marken', localePrefix);
      }

      if (targetUrl) {
        window.location.href = targetUrl;
      }
    } else {
      setActiveBrand(brand);
      applyBrandAttributes(brand);
      updateActiveBrandClass(brand);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBrandState);
  } else {
    initBrandState();
  }

  document.addEventListener('click', function (event) {
    const target = event.target.closest('#ed_default_brand, #ed_secondary_brand, #ed_third_brand');
    if (!target) return;

    if (target.id === 'ed_default_brand') {
      switchBrand(DEFAULT_BRAND, event);
    } else if (target.id === 'ed_secondary_brand') {
      switchBrand(SECONDARY_BRAND, event);
    } else if (target.id === 'ed_third_brand') {
      switchBrand(THIRD_BRAND, event);
    }
  }, true);

  document.addEventListener('click', function (event) {
    var productCard = event.target.closest('.product-item, .product-item-meta, .product-item-spotlight, .ela-product-item');
    if (!productCard) return;

    var brandEl = productCard.querySelector('[data-brand-target]');
    if (!brandEl) return;

    var targetBrand = brandEl.getAttribute('data-brand-target');
    if (!targetBrand) return;

    setActiveBrand(targetBrand);
  }, true);

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      initBrandState();
    }
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      setTimeout(function () {
        initBrandState();
      }, 10);
    });

    document.addEventListener('shopify:section:select', function (event) {
      setTimeout(function () {
        initBrandState();
      }, 10);
    });

    document.addEventListener('shopify:section:reorder', function (event) {
      setTimeout(function () {
        initBrandState();
      }, 10);
    });

    document.addEventListener('shopify:theme:select', function (event) {
      setTimeout(function () {
        initBrandState();
      }, 10);
    });
  }

  function watchForPdpBrandMarker() {
    try {
      if (!document.body) return;

      var isPdp =
        (document.body.classList && document.body.classList.contains('template-product')) ||
        (window.location && window.location.pathname && window.location.pathname.indexOf('/products/') !== -1);

      var isCollection =
        (document.body.classList && (document.body.classList.contains('template-collection') || document.body.classList.contains('template--collection'))) ||
        (window.location && window.location.pathname && window.location.pathname.indexOf('/collections/') !== -1);

      if (!isPdp && !isCollection) return;

      var initialOverride = getPageBrandOverride();
      if (initialOverride) {
        applyEffectiveBrand(initialOverride);
      }

      if (isPdp) {
        var pdpObserver = new MutationObserver(function (mutations) {
          var found = false;
          mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
              if (found || node.nodeType !== 1) return;
              var isPdpMarker = false;
              if (node.matches && node.matches('[data-brand-target]')) {
                var parent = node.closest('.pdp-title-wrap, product-rerender, .product');
                if (parent) isPdpMarker = true;
              } else if (node.querySelector) {
                var marker = node.querySelector('[data-brand-target]');
                if (marker) {
                  var parent = marker.closest('.pdp-title-wrap, product-rerender, .product');
                  if (parent) isPdpMarker = true;
                }
              }
              if (isPdpMarker) found = true;
            });
          });

          if (found) {
            var override = getPageBrandOverride();
            if (override) {
              applyEffectiveBrand(override);
            }
          }
        });

        pdpObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
      } else if (isCollection) {
        var collectionObserver = new MutationObserver(function (mutations) {
          var found = false;
          mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
              if (found || node.nodeType !== 1) return;
              var isCollectionMarker = false;
              if (node.matches && node.matches('.collection-brand-marker[data-brand-target]')) {
                isCollectionMarker = true;
              } else if (node.querySelector && node.querySelector('.collection-brand-marker[data-brand-target]')) {
                isCollectionMarker = true;
              }
              if (isCollectionMarker) found = true;
            });
          });

          if (found) {
            var override = getPageBrandOverride();
            if (override) {
              applyEffectiveBrand(override);
            }
          }
        });

        collectionObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    } catch (e) {
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForPdpBrandMarker);
  } else {
    watchForPdpBrandMarker();
  }

  function ensureProductFormsInitialized() {
    const productForms = document.querySelectorAll('form[is="product-form"]');
    productForms.forEach(function (form) {
      if (form.id && typeof form.id === 'object' && form.id.disabled !== undefined) {
        form.id.disabled = false;
      } else {
        const idInput = form.querySelector('input[name="id"]');
        if (idInput && idInput.disabled) {
          idInput.disabled = false;
        }
      }
    });
  }

  setTimeout(function () {
    ensureProductFormsInitialized();
  }, 100);

  var brandObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' &&
        (mutation.attributeName === 'data-brand' || mutation.attributeName === 'id')) {
        setTimeout(function () {
          ensureProductFormsInitialized();
        }, 50);
      }
    });
  });

  if (document.documentElement) {
    brandObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-brand', 'id']
    });
  }
  if (document.body) {
    brandObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['data-brand', 'id']
    });
  }

  var formObserver = new MutationObserver(function (mutations) {
    var shouldCheck = false;
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (node.matches && node.matches('form[is="product-form"]')) {
            shouldCheck = true;
          } else if (node.querySelector && node.querySelector('form[is="product-form"]')) {
            shouldCheck = true;
          }
        }
      });
    });
    if (shouldCheck) {
      setTimeout(function () {
        ensureProductFormsInitialized();
      }, 50);
    }
  });

  if (document.body) {
    formObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // AM collection brand filter
  (function () {
    var AM_LIST_CLASS = 'product__list__am';
    var AM_FILTER_STORAGE_KEY = 'ed_am_collection_filter';
    var currentFilter = 'all';

    function normalizeFilter(value) {
      if (value === 'default' || value === 'ela-beauty') {
        return value;
      }
      return 'all';
    }

    function filterToModifier(filter) {
      if (filter === 'default') {
        return 'product__list__am--default';
      }
      if (filter === 'ela-beauty') {
        return 'product__list__am--ela-beauty';
      }
      return 'product__list__am--alle-marken';
    }

    function applyFilterToList(listEl, filter) {
      if (!listEl) return;

      var modifiers = [
        'product__list__am--default',
        'product__list__am--ela-beauty',
        'product__list__am--alle-marken'
      ];

      modifiers.forEach(function (cls) {
        listEl.classList.remove(cls);
      });

      listEl.classList.add(filterToModifier(filter));
    }

    function applyFilterToAllLists(filter) {
      var lists = document.querySelectorAll('.' + AM_LIST_CLASS);
      lists.forEach(function (listEl) {
        applyFilterToList(listEl, filter);
      });
    }

    function applyProductFilter(filter) {
      var productList = document.querySelector('.' + AM_LIST_CLASS);
      if (!productList) return;

      var wrappers = productList.querySelectorAll('.product-item-brand-wrapper');
      if (!wrappers.length) return;

      wrappers.forEach(function (wrapper) {
        var brandEl = wrapper.querySelector('[data-brand-target]');
        var targetBrand = brandEl ? brandEl.getAttribute('data-brand-target') : null;

        var show = true;
        if (filter === 'default') {
          show = !targetBrand || targetBrand === 'default';
        } else if (filter === 'ela-beauty') {
          show = targetBrand === 'ela-beauty';
        } else {
          show = true;
        }

        if (show) {
          wrapper.classList.remove('ed-brand-filter-hidden');
        } else {
          wrapper.classList.add('ed-brand-filter-hidden');
        }
      });
    }

    function setActiveButton(filter) {
      var navs = document.querySelectorAll('.ed_facets_inner_nav[data-ed-brand-filter-nav]');
      if (!navs.length) return;

      navs.forEach(function (nav) {
        var buttons = nav.querySelectorAll('.ed_facets_inner_nav_item[data-brand-filter]');
        if (!buttons.length) return;

        buttons.forEach(function (btn) {
          var btnFilter = normalizeFilter(btn.getAttribute('data-brand-filter') || 'all');
          if (btnFilter === filter) {
            btn.classList.add('active');
          } else {
            btn.classList.remove('active');
          }
        });
      });
    }

    function initAmCollectionBrandToggle() {
      try {
        var nav = document.querySelector('.ed_facets_inner_nav[data-ed-brand-filter-nav]');
        if (!nav) return;

        var activeBtn = nav.querySelector('.ed_facets_inner_nav_item.active[data-brand-filter]');
        if (activeBtn) {
          currentFilter = normalizeFilter(activeBtn.getAttribute('data-brand-filter') || 'all');
        } else {
          try {
            var stored = window.localStorage && window.localStorage.getItem(AM_FILTER_STORAGE_KEY);
            if (stored) {
              currentFilter = normalizeFilter(stored);
            }
          } catch (e) {
            currentFilter = 'all';
          }
        }

        setActiveButton(currentFilter);
        applyFilterToAllLists(currentFilter);
        applyProductFilter(currentFilter);

        if (document.body) {
          var listObserver = new MutationObserver(function (mutations) {
            var foundNewList = false;
            var foundNewProducts = false;
            var foundNewNav = false;

            mutations.forEach(function (mutation) {
              mutation.addedNodes.forEach(function (node) {
                if (node.nodeType !== 1) return;

                if (node.matches && node.matches('.' + AM_LIST_CLASS)) {
                  foundNewList = true;
                } else if (node.querySelector && node.querySelector('.' + AM_LIST_CLASS)) {
                  foundNewList = true;
                }

                if (node.matches && node.matches('.product-item-brand-wrapper')) {
                  foundNewProducts = true;
                } else if (node.querySelector && node.querySelector('.product-item-brand-wrapper')) {
                  foundNewProducts = true;
                }

                if (node.matches && node.matches('.ed_facets_inner_nav[data-ed-brand-filter-nav]')) {
                  foundNewNav = true;
                } else if (node.querySelector && node.querySelector('.ed_facets_inner_nav[data-ed-brand-filter-nav]')) {
                  foundNewNav = true;
                }
              });
            });

            if (foundNewList) {
              applyFilterToAllLists(currentFilter);
            }
            if (foundNewList || foundNewProducts) {
              applyProductFilter(currentFilter);
            }
            if (foundNewNav) {
              setActiveButton(currentFilter);
            }
          });

          listObserver.observe(document.body, {
            childList: true,
            subtree: true
          });
        }
      } catch (e) {
      }
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('.ed_facets_inner_nav_item[data-brand-filter]');
      if (!button) return;
      if (!button.closest('.ed_facets_inner_nav[data-ed-brand-filter-nav]')) return;

      var value = normalizeFilter(button.getAttribute('data-brand-filter') || 'all');
      currentFilter = value;
      setActiveButton(currentFilter);
      applyFilterToAllLists(currentFilter);
      applyProductFilter(currentFilter);
      try {
        window.localStorage && window.localStorage.setItem(AM_FILTER_STORAGE_KEY, currentFilter);
      } catch (e) {
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAmCollectionBrandToggle);
    } else {
      initAmCollectionBrandToggle();
    }
  })();
})();
